export function buildNextParam(path: string, search?: Record<string, string>): string {
  const qs = search && Object.keys(search).length ? `?${new URLSearchParams(search)}` : "";
  return `${path}${qs}`;
}

export function resolveNextPath(next?: string): { to: string; search: Record<string, string> } {
  if (!next) return { to: "/dashboard", search: {} };
  const [pathname, qs] = next.split("?");
  return { to: pathname, search: qs ? Object.fromEntries(new URLSearchParams(qs)) : {} };
}
